import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environment/environment';

import { Observable, throwError } from 'rxjs'; // Add throwError import
import { catchError } from 'rxjs/operators'; // Add catchError import
import { ToastMessageService } from './toast-message.service'; // Import ToasterService

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    baseUrl = environment.baseUrl;

  constructor(
    private httpService: HttpClient,
    private toasterService: ToastMessageService
    ) { }

    login(data: any) {
        return this.httpService.post(`${this.baseUrl}login`, data);
    }

    logout() {
        return this.httpService.post(`${this.baseUrl}logout`,{});
    }

    getCurrentUser(): any {
        const userData = localStorage.getItem('userData') || sessionStorage.getItem('userData');
        return userData ? JSON.parse(userData) : null;
    }

    getCurrentUserRole(): string {
        const user = this.getCurrentUser();
        return user?.role || '';
    }

    requestPasswordReset(email: string) {
        return this.httpService.post(`${this.baseUrl}requestPasswordReset`, { email })
            .pipe(
                catchError((error) => {
                    this.toasterService.toastOnError('Error', error.error?.message || 'Failed to send password reset email');
                    return throwError(() => new Error(error));
                })
            );
    }

    resetPasswordWithToken(resetData: {
        email: string,
        token: string,
        new_password: string,
        new_password_confirmation: string
    }) {
        return this.httpService.post(`${this.baseUrl}resetPasswordWithToken`, resetData)
            .pipe(
                catchError((error) => {
                    this.toasterService.toastOnError('Error', error.error?.message || 'Failed to reset password');
                    return throwError(() => new Error(error));
                })
            );
    }

}
